import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import DomainImage from '../../../components/DomainImage';

export const COLUMNS = (t) => [
    {
        label: t('commerce.domain_detail.columns.url'),
        key: 'url',
        data: 'url',
        Component: Cell,
        sortType: 'string',
        cellSize: 'minmax(300px, 3fr)',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div className="d-flex row justify-content-between w-100">
                    <div className="col-10 d-flex row justify-content-between">
                        <div className="col-2">
                            <DomainImage domain_name={data} className="domain_img" />
                        </div>
                        <strong className="col-10 wrap-text">{data}</strong>
                    </div>
                    <div className="col-2 d-flex align-items-center">
                        <a
                            target="_blank"
                            className="link-website d-inline-flex align-items-center justify-content-center"
                            href={data}
                            rel="noreferrer"
                        >
                            <i className="icon-external-link"></i>
                        </a>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('commerce.domain_detail.columns.keyword'),
        key: 'keyword',
        data: 'keyword',
        sortType: 'string',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{data}</span>,
    },
    {
        label: t('commerce.domain_detail.columns.position'),
        key: 'position',
        data: 'position',
        sortType: (array) => array.sort((a, b) => b.position - a.position),
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0 a')}</span>,
    },
    {
        label: t('commerce.domain_detail.columns.organic_keywords'),
        key: 'organic_keywords',
        data: 'organic_keywords',
        sortType: 'number',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0 a')}</span>,
    },
    {
        label: t('commerce.domain_detail.columns.organic_traffic'),
        key: 'organic_traffic',
        data: 'organic_traffic',
        sortType: 'number',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0 a')}</span>,
    },
    {
        label: t('commerce.domain_detail.columns.organic_cost'),
        key: 'organic_cost',
        data: 'organic_cost',
        sortType: 'number',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0 a')}</span>,
    },
    {
        label: t('commerce.domain_detail.columns.adwords_keywords'),
        key: 'adwords_keywords',
        data: 'adwords_keywords',
        sortType: 'number',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0 a')}</span>,
    },
    {
        label: t('commerce.domain_detail.columns.adwords_traffic'),
        key: 'adwords_traffic',
        data: 'adwords_traffic',
        sortType: 'number',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0 a')}</span>,
    },
    {
        label: t('commerce.domain_detail.columns.adwords_cost'),
        key: 'adwords_cost',
        data: 'adwords_cost',
        sortType: 'number',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <span className="wripe">{numeral(data).format('0 a')}</span>,
    },
];
